import React from 'react';
import { Link } from 'react-router-dom';
import { LuBed, LuBath, LuLayers, LuSquareAsterisk } from "react-icons/lu";

function HouseItem({ house, isHor }) {
    if (!house) return null;

    return (
        <div className={`
            bg-white rounded-2xl overflow-hidden shadow-sm card-shadow 
            group border border-outline-variant/30 hover:border-primary/20 
            transition-all duration-500 
            ${isHor ? 'w-80 flex-shrink-0' : 'w-full'}
        `}>
            <div className="aspect-[4/3] overflow-hidden relative">
                <Link to={`/house/${house.slug}`}>
                    <img
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        src={house.image}
                        alt={house.name}
                    />
                </Link>
                {house.category?.name && (
                    <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-md text-primary px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-[0.2em] shadow-sm">
                        {house.category.name}
                    </div>
                )}
            </div>

            <div className="p-6">
                <Link to={`/house/${house.slug}`}>
                    <h3 className="font-headline font-black text-xl text-on-surface mb-4 group-hover:text-primary transition-colors line-clamp-1">
                        {house.name}
                    </h3>
                </Link>

                <div className="grid grid-cols-2 gap-y-4 gap-x-2 mb-6">
                    <div className="flex items-center gap-2 text-on-surface-variant">
                        <div className="w-8 h-8 rounded-lg bg-primary/5 flex items-center justify-center text-primary">
                            <LuBed size={18} />
                        </div>
                        <span className="text-sm font-bold">{house.bedrooms || '-'} Bed</span>
                    </div>
                    <div className="flex items-center gap-2 text-on-surface-variant">
                        <div className="w-8 h-8 rounded-lg bg-primary/5 flex items-center justify-center text-primary">
                            <LuBath size={18} />
                        </div>
                        <span className="text-sm font-bold">{house.bathrooms || '-'} Bath</span>
                    </div>
                    <div className="flex items-center gap-2 text-on-surface-variant">
                        <div className="w-8 h-8 rounded-lg bg-primary/5 flex items-center justify-center text-primary">
                            <LuLayers size={18} />
                        </div>
                        <span className="text-sm font-bold">{house.stories || '-'} Story</span>
                    </div>
                    <div className="flex items-center gap-2 text-on-surface-variant">
                        <div className="w-8 h-8 rounded-lg bg-primary/5 flex items-center justify-center text-primary">
                            <LuSquareAsterisk size={18} />
                        </div>
                        <span className="text-sm font-bold">{house.square_meters?.toLocaleString() || '-'} sqft</span>
                    </div>
                </div>

                <div className="flex gap-3">
                    <Link
                        to={`/house/${house.slug}`}
                        className="flex-1 px-4 py-3 bg-surface-container-low text-primary font-black text-[10px] rounded-xl hover:bg-primary hover:text-white transition-all text-center uppercase tracking-widest"
                    >
                        View Details
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default HouseItem;